exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rerouteComment[data-v-af1ce80c] {\n  background-color: #f1959d;\n  width: 700px;\n  padding: 10px;\n}\n.rerouteComment > textarea[data-v-af1ce80c] {\n    background-color: #cc76a8;\n}\n.el-checkbox.is-bordered[data-v-af1ce80c] {\n  padding: 9px 20px 9px 10px;\n  border-radius: 4px;\n  border: 1px solid #7da0b8;\n}\n.el-input[data-v-af1ce80c] {\n  width: 240px;\n}\nhr[data-v-af1ce80c] {\n  border-color: #7da0b8;\n}\n.big.el-select[data-v-af1ce80c] {\n  width: 450px;\n}\n.biggest.el-textarea[data-v-af1ce80c] {\n  width: 700px;\n}\n.el-checkbox__label[data-v-af1ce80c] {\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af1ce80c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/PrecheckerJudgment.vue
// module id = 6m+O
// module chunks = 1